import { selectFeatureFlags } from 'core/userContext/selectors';
import { useSelector } from 'react-redux';
import {
  ACTIVE_USERS_ADDED,
  CURRENT_USERS,
  TOTAL_USERS_HIGH_WATERMARK,
  USERS,
  USERS_ADDED,
} from '../../../constants';
import { useBillingQueryContext } from '../../../contexts';
import { createHighWatermarkCaption, yesterdayDisplay } from '../../../utils';
import { LoadingCard } from '../LoadingCard';
import { MetricRow } from '../MetricRow';
import { MetricTile } from '../MetricTile';
import { ProjectBreakdownLink } from '../ProjectBreakdownLink';
import { Container, Header, MainContent, Marquee, RowsWrapper, Title } from '../styled';
import { USERS_CARD_IDS, USERS_CARD_TEXT } from './constants';

const {
  cardTitle,
  projectBreakdownUrl,
  totalUsersAddedInPeriodName,
  totalUsersAddedInPeriodDescription,
  totalUsersAllTimeDescription,
  totalUsersAllTimeName,
  totalUsersHighWatermarkDescription,
  totalUsersHighWatermarkName,
} = USERS_CARD_TEXT;

export const UsersCard = () => {
  const { AllowActiveUsersMetricInBilling } = useSelector(selectFeatureFlags);
  const { pickOrgMetric, pickOrgValue, displayDateRange, displayEndDate, isLoading } =
    useBillingQueryContext();

  const usersHighWatermark = pickOrgMetric(TOTAL_USERS_HIGH_WATERMARK);

  const totalUsersAllTime = pickOrgValue(USERS);
  const totalUsersHighWatermark = pickOrgValue(TOTAL_USERS_HIGH_WATERMARK);
  const totalUsersAddedInPeriod = pickOrgValue(USERS_ADDED);

  return isLoading ? (
    <LoadingCard />
  ) : (
    <Container data-test={USERS_CARD_IDS.cardId}>
      <Header>
        <Title>{cardTitle}</Title>
        <div>
          <ProjectBreakdownLink to={projectBreakdownUrl} />
        </div>
      </Header>
      <Marquee>
        <MetricTile
          label="Current"
          tooltip="Total number of users currently in all projects"
          caption={`As of ${yesterdayDisplay()}`}
          value={pickOrgValue(CURRENT_USERS)}
        />
      </Marquee>
      <MainContent>
        <RowsWrapper>
          <MetricRow
            label={totalUsersAllTimeName}
            caption={`As of ${displayEndDate}`}
            tooltip={`${totalUsersAllTimeDescription} ${displayEndDate}`}
            value={totalUsersAllTime}
          />
          <MetricRow
            label={totalUsersAddedInPeriodName}
            tooltip={totalUsersAddedInPeriodDescription}
            caption={`Between ${displayDateRange}`}
            value={totalUsersAddedInPeriod}
          />
          {AllowActiveUsersMetricInBilling && (
            <MetricRow label="Active users added" value={pickOrgValue(ACTIVE_USERS_ADDED)} />
          )}
          <MetricRow
            label={totalUsersHighWatermarkName}
            caption={usersHighWatermark ? createHighWatermarkCaption(usersHighWatermark) : ''}
            tooltip={`${totalUsersHighWatermarkDescription} ${displayDateRange}`}
            value={totalUsersHighWatermark}
          />
        </RowsWrapper>
      </MainContent>
    </Container>
  );
};
